import store from "../store";
import { getFirstAllowedPage } from "../utils/permissionHelpers";

export default [
  {
    path: "*",
    meta: {
      public: true,
    },
    redirect: {
      path: "/404",
    },
  },
  {
    path: "/404",
    meta: {
      public: true,
    },
    name: "NotFound",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/NotFound.vue`
      ),
  },
  {
    path: "/test",
    meta: { breadcrumb: true, title: "routeTitles.test" },
    name: "Test",
    component: () => import("@/views/Test"),
  },

  {
    path: "/login",
    meta: {
      public: true,
    },
    name: "Login",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Login.vue`
      ),
    beforeEnter(to, from, next) {
      if (store.state.user) {
        // If user doesn't have permission for Requests, redirect to first allowed page
        const userPermissions = store.state.user.permissions || [];
        const firstPage = getFirstAllowedPage(userPermissions);
        next(firstPage);
      } else {
        next();
      }
    },
  },
  {
    path: "/reset-password",
    meta: {  public: true,breadcrumb: true, title: "auth.resetPassword" },
    name: "Reset Password",
    component: () => import("@/views/ResetPassword"),
  },
  {
    path: "/reset-password-email",
    meta: { public: true, breadcrumb: true, title: "auth.resetPassword" },
    // QA V4 W3 (#23): distinct name — this route and /reset-password both used
    // the name "Reset Password", which makes vue-router name lookups ambiguous.
    name: "ResetPasswordEmail",
    component: () => import("@/views/ResetPasswordEmail"),
  },
  {
    path: "",
    meta: { breadcrumb: true },
    name: "Root",
    async beforeEnter(to, from, next) {
      await store.dispatch("validateToken");
      if (!store.state.user) next(`login?next=${to.name}`);
      else {
        await store.dispatch("initSocket");
        next();
      }
    },
    component: () => import("@/components/RootComponent"),
    redirect: { name: "Requests" },
    children: [
      // {
      //     path: '/operator_kpi',
      //     meta: { breadcrumb: true, title: "Operator KPI" },
      //     name: "OperatorKPI",
      //     component: () => import("@/views/CompetitiveCharts")
      // },
      // {
      //     path: '/cancellation_table',
      //     meta: { breadcrumb: true, title: "Cancellation Table" },
      //     name: "CancellationTable",
      // component: () => import("@/views/CancellationTable")
      // },
      {
        path: "/debug_view",
        meta: { breadcrumb: true, title: "routeTitles.debugView" },
        name: "Debug View",
        component: () => import("@/views/DebugView"),
      },
      // {
      //     path: '/lateness',
      //     meta: { breadcrumb: true, title: 'Lateness' },
      //     name: 'Lateness',
      //     component: () => import('@/views/monitoring/Lateness')
      // },
      {
        path: "/notifications",
        meta: { breadcrumb: true, title: "routeTitles.notifications" },
        name: "AllNotifications",
        component: () => import("@/views/AllNotifications"),
      },
      {
        path: "/available_interview_times",
        meta: { breadcrumb: true, title: "routeTitles.availableInterviewTimes" },
        name: "AvailableInterviewTimes",
        component: () =>
          import("@/views/driver_acquisition/AvailableInterviewTimes"),
      },
      {
        path: "/interviews",
        meta: { breadcrumb: true, title: "routeTitles.interviews" },
        name: "Interviews",
        component: () => import("@/views/driver_acquisition/Interviews"),
      },
      {
        path: "/dashboard",
        meta: { breadcrumb: true, title: "dashboardPage.pageTitle" },
        name: "Dashboard",
        component: () =>
          import(
            /* webpackChunkName: "routes" */
            `@/views/Dashboard`
          ),
      },
      {
        path: "/timeline",
        meta: { breadcrumb: true, title: "routeTitles.timeline" },
        name: "Timeline",
        component: () => import("@/views/dispatching/Timeline"),
      },
      {
        path: "/requests",
        meta: { breadcrumb: true, title: "requestsPage.pageTitle" },
        name: "Requests",
        component: () => import("@/views/dispatching/Requests"),
      },
      {
        path: "/path_drawer",
        meta: { breadcrumb: true, title: "routeTitles.pathDrawer" },
        name: "PathDrawer",
        component: () => import("@/views/monitoring/PathDrawer"),
      },
      {
        path: "/rides_tracker",
        meta: { breadcrumb: true, title: "routeTitles.map" },
        name: "RidesTracker",
        component: () => import("@/views/monitoring/RidesTracking"),
      },
      // {
      //     path: "/ai_stats",
      //     meta: { breadcrumb: true, title: "AiStats" },
      //     name: "AiStats",
      //     component:
      //         () => import("@/views/monitoring/AiStats")
      // },
      {
        path: "/staff",
        meta: { breadcrumb: true, title: "staffPage.pageTitle" },
        name: "Staff",
        component: () => import("@/views/users/List"),
      },
      {
        path: "/staff/add",
        meta: { breadcrumb: true, title: "staffPage.pageTitle" },
        name: "Staff Creation",
        component: () => import("@/views/users/AddStaff"),
      },
      {
        path: "/hotels",
        meta: { breadcrumb: true, title: "routeTitles.hotels" },
        name: "Hotels",
        component: () => import("@/views/hotels/HotelsN"),
      },
      {
        path: "/hotels/store",
        meta: { breadcrumb: true, title: "routeTitles.createHotel" },
        name: "Hotels Create",
        component: () => import("@/views/hotels/CreateHotelN"),
      },
      {
        path: "/hotels/edit/:id",
        meta: { breadcrumb: true, title: "routeTitles.editHotel" },
        name: "EditHotel",
        component: () => import("@/views/hotels/EditHotel"),
      },
      {
        path: "/hotelsUsers",
        meta: { breadcrumb: true, title: "routeTitles.users" },
        name: "HotelsUsers",
        component: () => import("@/views/hotels/Hotels"),
      },
      {
        path: "/restaurants",
        meta: { breadcrumb: true, title: "routeTitles.users" },
        name: "Restaurants",
        component: () => import("@/views/restaurants/RestaurantsN"),
      },
      {
        path: "/restaurants/store",
        meta: { breadcrumb: true, title: "routeTitles.createRestaurant" },
        name: "Restaurants Create",
        component: () => import("@/views/restaurants/CreateRestaurantN"),
      },
      {
        path: "/restaurants/edit/:id",
        meta: { breadcrumb: true, title: "routeTitles.editRestaurant" },
        name: "EditRestaurant",
        component: () => import("@/views/restaurants/EditRestaurant"),
      },
      {
        path: "/restaurantsUsers",
        meta: { breadcrumb: true, title: "routeTitles.users" },
        name: "RestaurantsUsers",
        component: () => import("@/views/restaurants/Restaurants"),
      },
      {
        path: "/companies",
        meta: { breadcrumb: true, title: "routeTitles.users" },
        name: "Companies",
        component: () => import("@/views/companies/Companies"),
      },
      {
        path: "/company-requests",
        meta: { breadcrumb: true, title: "routeTitles.companyRequests" },
        name: "CompanyRequests",
        component: () => import("@/views/company_requests/CompanyRequests"),
      },
      {
        path: "/company-request/:id",
        meta: { breadcrumb: true, title: "routeTitles.companyRequest" },
        name: "CompanyRequest",
        component: () => import("@/views/company_requests/Profile"),
      },
      {
        path: "/hotels/create",
        meta: { breadcrumb: true, title: "routeTitles.users" },
        name: "Hotels Create",
        component: () => import("@/views/hotels/CreateHotel"),
      },
      {
        path: "/restaurants/create",
        meta: { breadcrumb: true, title: "routeTitles.users" },
        name: "Create Restaurant ",
        component: () => import("@/views/restaurants/CreateRestaurant"),
      },
      {
        path: "/companies/create",
        meta: { breadcrumb: true, title: "routeTitles.users" },
        name: "Create Company ",
        component: () => import("@/views/companies/CreateCompany"),
      },
      {
        path: "/passengers/marketing",
        meta: { breadcrumb: true, title: "passengersPage.marketingTitle" },
        name: "PassengersMarketing",
        component: () => import("@/views/passengers/PassengersMarketing.vue"),
      },

      // {
      //     path: '/unresolved_leaves',
      //     meta: { breadcrumb: true, title: "Unresolved Leaves" },
      //     name: 'UnresolvedLeaves',
      //     component: () => import("@/views/Leave/UnresolvedLeaves")
      // },
      // {
      //     path: '/unresolved_extra_hours',
      //     meta: { breadcrumb: true, title: "UnresolvedExtraHours" },
      //     name: 'UnresolvedExtraHours',
      //     component: () => import("@/views/extra_hours/UnresolvedExtraHours")
      // },
      // {
      //     path: '/salary_reports',
      //     meta: { breadcrumb: true, title: "Salary Reports" },
      //     name: 'SalariesReports',
      //     // props: true,
      //     props: route => ({
      //         date: route.query.date,
      //         user_id: route.query.user_id,
      //         regenrate_option: (String(route.query.regenrate_option).toLowerCase() === 'true'),
      //         //  regenrate_option: route.query.regenrate_option,
      //         enable_employee_choose: (String(route.query.enable_employee_choose).toLowerCase() === 'true')
      //         //  enable_employee_choose: route.query.enable_employee_choose
      //     }),
      //     component: () => import("@/views/HRAccounting/SalaryReportIndex")
      // },
      // {
      //     path: '/salaries_reports',
      //     meta: { breadcrumb: true, title: "Salary Reports" },
      //     name: 'AllSalariesReports',
      //     component: () => import("@/views/HRAccounting/AllSalaryReportsIndex")
      // },
      // {
      //     path: '/employment_type',
      //     meta: { breadcrumb: true, title: "EmploymentTypes" },
      //     name: 'EmploymentTypes',
      //     component: () => import("@/views/HRAccounting/EmploymentTypes")
      // },
      // {
      //     path: '/salary_event',
      //     meta: { breadcrumb: true, title: "SalaryEvents" },
      //     name: 'SalaryEvents',
      //     component: () => import("@/views/HRAccounting/SalaryEvents")
      // },
      // {
      //     path: '/employment_type/:id/delay_policies',
      //     name: 'DelayPolices',
      //     meta: { breadcrumb: true, title: 'DelayPolices' },
      //     component: () => import("@/views/HRAccounting/DelayPolicies")
      // },
      // {
      //     path: '/employment_type/:id/general_holidays',
      //     name: 'GeneralHolidays',
      //     meta: { breadcrumb: true, title: 'General Holidays' },
      //     component: () => import("@/views/HRAccounting/GeneralHolidays")
      // },
      // {
      //     path: '/project_schedule',
      //     meta: { breadcrumb: true, title: "User Project Schedule" },
      //     name: 'UserProjectScheduleCalendar',
      //     component: () => import("@/views/UserProjectScheduleCalendar")
      // },
      // {
      //     path: '/users/:id',
      //     meta: { breadcrumb: true, title: "User Profile" },
      //     name: 'UserProfile',
      //     component: () => import("@/views/users/Profile")
      // },
      {
        path: "/users/:id",
        meta: { breadcrumb: true, title: "staffPage.profilePageTitle" },
        name: "UserProfile",
        component: () => import("@/views/users/StaffProfile"),
      },
      {
        path: "/unregistered_passengers",
        meta: { breadcrumb: true, title: "routeTitles.unregisteredPassengers" },
        name: "UnregisteredPassengers",
        component: () => import("@/components/monaco/UnregisteredAgent"),
        props: { provider: "passengers" },
      },
      {
        path: "/passengers",
        meta: { breadcrumb: true, title: "passengersPage.pageTitle" },
        name: "Passengers",
        component: () => import("@/views/passengers/Passengers"),
      },
       {
        path: "/business",
        meta: { breadcrumb: true, title: "businessPage.pageTitle" },
        name: "BusinessAccounts",
        component: () => import("@/views/passengers/Hotels"),
      },
      {
        path: "/unregistered_captains",
        meta: { breadcrumb: true, title: "routeTitles.unregisteredCaptains" },
        name: "UnregisteredCaptains",
        component: () => import("@/components/monaco/UnregisteredAgent"),
        props: { provider: "captains" },
      },
      {
        path: "/drivers",
        meta: { breadcrumb: true, title: "captainsPage.driversTitle" },
        name: "Drivers",
        component: () => import("@/views/captains/Captains"),
      },
       {
        path: "/transfer-centers",
        meta: { breadcrumb: true, title: "transferCentersPage.pageTitle" },
        name: "TransferCenters",
        component: () => import("@/views/transfer_centers/List"),
      },
       {
        path: "/transfer-centers/create",
        meta: { breadcrumb: true, title: "transferCentersPage.createTitle" },
        name: "TransferCenterCreate",
        component: () => import("@/views/transfer_centers/Create"),
      },
       {
        path: "/transfer-centers/:id",
        meta: { breadcrumb: true, title: "transferCentersPage.profileTitle" },
        name: "TransferCenterProfile",
        component: () => import("@/views/transfer_centers/Profile"),
      },
      {
        path: "/driver-accounting",
        meta: { breadcrumb: true, title: "accountingPage.driversAccountingTitle" },
        name: "DriversAccounting",
        component: () => import("@/views/accounting/CaptainAccounting"),
      },
      {
        path: "/transfer-center-accounting",
        meta: { breadcrumb: true, title: "accountingPage.transferCentersAccountingTitle" },
        name: "TransferCentersAccounting",
        component: () => import("@/views/accounting/TransferCenterAccounting"),
      },
      {
        path: "/driver-transfers",
        meta: { breadcrumb: true, title: "accountingPage.driversTransfersTitle" },
        name: "DriversTransfers",
        component: () => import("@/views/accounting/DriversTransfers"),
      },
      {
        path: "/transfer-center-transfers",
        meta: { breadcrumb: true, title: "accountingPage.transferCentersTransfersTitle" },
        name: "TransferCenterTransfers",
        component: () => import("@/views/accounting/TransferCenterTransfers"),
      },
      {
        path: "/marketing-vouchers",
        meta: { breadcrumb: true, title: "vouchersPage.pageTitleMarketing" },
        name: "MarketingVouchers",
        component: () => import("@/views/vouchers/marketing_vouchers/MarketingVouchers"),
      },
      {
        path: "/personal-vouchers",
        meta: { breadcrumb: true, title: "vouchersPage.pageTitlePersonal" },
        name: "PersonalVouchers",
        component: () => import("@/views/vouchers/personal_vouchers/PersonalVouchers"),
      },
      {
        path: "/tickets_monitoring",
        meta: { breadcrumb: true, title: "routeTitles.ticketsMonitoring" },
        name: "TicketsMonitoring",
        component: () =>
          import("@/views/customer_care/ticketing/TicketsMonitoring"),
      },
      {
        path: "/car_requests",
        meta: { breadcrumb: true, title: "captainCreatePage.pageTitleCarRequests" },
        name: "CarRequests",
        component: () => import("@/views/captains/CarRequests"),
      },
      {
        path: "/rating_causes",
        name: "RatingCauses",
        meta: { breadcrumb: true, title: "routeTitles.ratingCauses" },
        component: () => import("@/views/customer_support/RatingCauses"),
      },
      // {
      //     path: '/first_ride_pax',
      //     name: 'FirstRidePax',
      //     meta: { breadcrumb: true, title: 'First Ride Pax' },
      //     component: () => import("@/views/customer_support/FirstRidePax")
      // },
      {
        path: "/bonus_package",
        name: "Bonus Package",
        meta: { breadcrumb: true, title: "routeTitles.bonusPackages" },
        component: () => import("@/views/BonusPackage/Index"),
      },
      {
        path: "/bonus_package/:id",
        name: "Bonus Package Details",
        meta: { breadcrumb: true, title: "routeTitles.bonusPackage" },
        component: () => import("@/views/BonusPackage/Details"),
      },
      {
        path: "/bonus_package/:id/bonuses",
        name: "Bonuses",
        meta: { breadcrumb: true, title: "routeTitles.bonuses" },
        component: () => import("@/views/BonusPackage/Bonuses"),
      },
      {
        path: "/bonus/:id/time_slices",
        name: "Bonus Time Slices",
        meta: { breadcrumb: true, title: "routeTitles.bonusTimeSlices" },
        component: () => import("@/views/BonusPackage/BonusTimeSlices"),
      },
      {
        path: "/conditional_bonus",
        name: "Anas",
        meta: { breadcrumb: true, title: "routeTitles.anas" },
        component: () => import("@/views/customer_support/Anas"),
      },
      {
        path: "/services",
        name: "Services",
        meta: { breadcrumb: true, title: "catalogPage.pageTitleServices" },
        component: () => import("@/views/services/List"),
      },
      {
        path: "/cameras",
        name: "Cameras",
        meta: { breadcrumb: true, title: "camerasPage.pageTitle" },
        component: () => import("@/views/cameras/List"),
      },
      {
        path: "/cameras/logs",
        name: "CameraStreamLogs",
        meta: { breadcrumb: true, title: "camerasPage.logsTitle" },
        component: () => import("@/views/cameras/StreamLogs"),
      },
      {
        path: "/car-owners",
        name: "CarOwners",
        meta: { breadcrumb: true, title: "carOwnersPage.pageTitle" },
        component: () => import("@/views/car_owners/CarOwners"),
      },
      {
        path: "/business-accounts",
        name: "BusinessAccountBalances",
        meta: { breadcrumb: true, title: "routeTitles.businessBalances" },
        component: () => import("@/views/business_accounts/BusinessAccounts"),
      },
      {
        path: "/passenger-wallets",
        name: "PassengerWallets",
        meta: { breadcrumb: true, title: "walletsPage.pageTitle" },
        component: () => import("@/views/wallets/Wallets"),
      },
      {
        path: "/services/:id/prices",
        name: "ServicePrices",
        meta: { breadcrumb: true, title: "catalogPage.pageTitlePrices" },
        component: () => import("@/views/services/Prices"),
      },
      // {
      //     path: "user-settings",
      //     name: "UserSettings",
      //     meta: { breadcrumb: true, title: "User Settings" },
      //     component: () => import("@/views/users/Settings")
      // },
      {
        path: "/services/:id/locations",
        name: "ServiceLocations",
        meta: { breadcrumb: true, title: "catalogPage.pageTitleLocations" },
        component: () => import("@/views/services/Locations"),
      },
      {
        path: "/services/:id/cars",
        name: "ServiceCars",
        meta: { breadcrumb: true, title: "catalogPage.pageTitleCars" },
        component: () => import("@/views/services/Cars"),
      },
      // {
      //     path: "/notification_centre",
      //     name: "NotificationCentre",
      //     meta: { breadcrumb: true, title: "NotificationCentre" },
      //     component: () => import("@/views/NotificationCentre")
      // },
      {
        path: "/payment-methods",
        name: "PaymentMethods",
        meta: { breadcrumb: true, title: "catalogPage.pageTitlePaymentMethods" },
        component: () => import("@/views/payment_methods/List"),
      },
      {
        path: "/car_brands",
        name: "CarBrands",
        meta: { breadcrumb: true, title: "catalogPage.pageTitleCarBrands" },
        component: () => import("@/views/types/CarBrands"),
      },
      // {
      //     path: "/weekly_present_captains",
      //     name: "WeeklyPresentCaptains",
      //     meta: { breadcrumb: true, title: "Weekly Present Captains" },
      //     component: () => import("@/views/captains/WeeklyPresent")
      // },
      {
        path: "/colors",
        name: "Colors",
        meta: { breadcrumb: true, title: "catalogPage.pageTitleColors" },
        component: () => import("@/views/types/Colors"),
      },
      {
        path: "/banks",
        name: "Banks",
        meta: { breadcrumb: true, title: "catalogPage.pageTitleBanks" },
        component: () => import("@/views/types/Banks"),
      },
      {
        path: "/BarStatistics",
        name: "BarStatistics",
        meta: { breadcrumb: true, title: "statisticsPage.pageTitle" },
        component: () => import("@/views/Statistics"),
      },
      {
        path: "/monaco_editor",
        name: "MonacoEditor",
        meta: { breadcrumb: true, title: "routeTitles.monacoEditor" },
        component: () => import("@/views/MonacoEditor"),
      },
      {
        path: "/map_editor",
        name: "MapEditor",
        meta: { breadcrumb: true, title: "routeTitles.mapEditor" },
        component: () => import("@/views/MapEditor"),
      },
      {
        path: "/nationalities",
        name: "Nationalities",
        meta: { breadcrumb: true, title: "routeTitles.nationalities" },
        component: () => import("@/views/types/Nationalities"),
      },
      {
        path: "/car_brands/:id/models",
        name: "CarBrandModels",
        meta: { breadcrumb: true, title: "catalogPage.pageTitleModels" },
        component: () => import("@/views/types/CarBrandModels"),
      },
      {
        path: "/location_containers",
        name: "LocationContainers",
        meta: { breadcrumb: true, title: "routeTitles.locationContainers" },
        component: () => import("@/views/locations/ContainerList"),
      },
      {
        path: "/location_containers/add",
        name: "LocationContainersAdder",
        meta: { breadcrumb: true, title: "routeTitles.addLocationContainer" },
        component: () => import("@/views/locations/ContainerEditor"),
      },
      {
        path: "/location_containers/:id",
        name: "LocationContainerEditor",
        meta: { breadcrumb: true, title: "routeTitles.editLocationContainer" },
        component: () => import("@/views/locations/ContainerEditor"),
      },
      {
        path: "/landmarks",
        name: "Landmarks",
        meta: { breadcrumb: true, title: "routeTitles.landmarks" },
        component: () => import("@/views/locations/LandmarkList"),
      },
      {
        path: "/stations",
        name: "stations",
        meta: { breadcrumb: true, title: "routeTitles.stations" },
        component: () => import("@/views/locations/StationList"),
      },
      {
        path: "/stations/add",
        name: "StationsAdder",
        meta: { breadcrumb: true, title: "routeTitles.addStation" },
        component: () => import("@/views/locations/StationEditor"),
      },
      {
        path: "/landmarks/add",
        name: "LandmarksAdder",
        meta: { breadcrumb: true, title: "routeTitles.addLandmark" },
        component: () => import("@/views/locations/LandmarkEditor"),
      },
      {
        path: "/sectors",
        name: "Sectors",
        meta: { breadcrumb: true, title: "routeTitles.sectors" },
        component: () => import("@/views/locations/Sectors"),
      },
      {
        path: "/landmarks/:id",
        name: "LandmarksEditor",
        meta: { breadcrumb: true, title: "routeTitles.editLandmark" },
        component: () => import("@/views/locations/LandmarkEditor"),
      },
      {
        path: "/bookings/:id",
        name: "Bookings",
        meta: { breadcrumb: true, title: "ridePage.pageTitle" },
        component: () => import("@/views/RidePage"),
      },
      {
        // Backward compatible: old rides details URL
        path: "/rides/:id",
        redirect: (to) => ({ name: "Bookings", params: { id: to.params.id } }),
      },
      {
        path: "/SeasonalDestinations/update",
        name: "EditSeasonalDestinations",
        meta: { breadcrumb: true, title: "routeTitles.updateSeasonalDestinations" },
        component: () => import("@/views/area/EditClusters"),
      },
      // {
      //     path: "/get_qr_code",
      //     name: "GetQrCode",
      //     meta: { breadcrumb: true, title: "QR Code" },
      //     component: () => import("@/views/GetQrCode")
      // },
      {
        path: "/VehicleTypesManagement",
        name: "VehicleTypesManagement",
        meta: { breadcrumb: true, title: "routeTitles.vehicleType" },
        component: () => import("@/views/types/VehicleType"),
      },
      {
        path: "contract_template/level",
        meta: { breadcrumb: true, title: "routeTitles.levels" },
        name: "Level",
        component: () => import("@/views/contract_template/Level"),
      },
      // {
      //     path: '/advertising_campaign',
      //     meta: { breadcrumb: true, title: "Advertising Campaign" },
      //     name: 'AdvertisingCampaign',
      //     component: () => import("@/views/advertising_campaign/AdvertisingCampaign")
      // },
      {
        path: "/change_captain_reasons",
        meta: { breadcrumb: true, title: "routeTitles.changeCaptainReasons" },
        name: "ChangeCaptainReasons",
        component: () =>
          import("@/views/change_captain_reasons/ChangeCaptainReasons"),
      },
      {
        path: "/contract_template",
        meta: { breadcrumb: true, title: "routeTitles.contractTemplate" },
        name: "contract_template",
        component: () => import("@/views/contract_template/ContractTemplate"),
      },
      {
        path: "/stations/:id",
        name: "StationsEditor",
        meta: { breadcrumb: true, title: "routeTitles.editStation" },
        component: () => import("@/views/locations/StationEditor"),
      },
      {
        path: "/contract_template",
        meta: { breadcrumb: true, title: "routeTitles.contractTemplate" },
        name: "contract_template",
        component: () => import("@/views/contract_template/ContractTemplate"),
      },
      {
        path: "/landmarks/:id",
        name: "LandmarksEditor",
        meta: { breadcrumb: true, title: "routeTitles.editLandmark" },
        component: () => import("@/views/locations/LandmarkEditor"),
      },
      // {
      //     path: "user_schedule",
      //     name: "UserSchedule",
      //     meta: { breadcrumb: true, title: "User Schedule" },
      //     component: () => import("@/views/UserSchedule")
      // },
      {
        path: "/restricted-areas",
        name: "RestrictedAreas",
        meta: {
          breadcrumb: true,
          title: "routeTitles.restrictedAreas",
        },
        component: () => import("@/views/locations/RestrictedAreas"),
      },
      {
        path: "/restricted-areas/add",
        name: "RestrictedAreasAdder",
        meta: {
          breadcrumb: true,
          title: "routeTitles.addRestrictedArea"
        },
        component: () => import("@/views/locations/RestrictedAreaEditor"),
      },
      {
        path: "/restricted-areas/:id",
        name: "RestrictedAreasEditor",
        meta: {
          breadcrumb: true,
          title: "routeTitles.editRestrictedArea"
        },
        component: () => import("@/views/locations/RestrictedAreaEditor"),
      },
      {
        path: "/zones",
        name: "Zones",
        meta: {
          breadcrumb: true,
          title: "zonesPage.pageTitle",
        },
        component: () => import("@/views/locations/LocationClusters"),
      },
      {
        path: "/zones/add",
        name: "ZonesAdder",
        meta: {
          breadcrumb: true,
          title: "zonesPage.editorPageTitle"
        },
        component: () => import("@/views/locations/Editor"),
      },
      {
        path: "/zones/:id",
        name: "ZonesEditor",
        meta: {
          breadcrumb: true,
          title: "zonesPage.editorPageTitle"
        },
        component: () => import("@/views/locations/Editor"),
      },
      {
        path: "/blacklist_locations",
        name: "BlacklistLocations",
        meta: { breadcrumb: true, title: "routeTitles.locations" },
        props: { blacklist: true },
        component: () => import("@/views/locations/List"),
      },
      {
        path: "/blacklist_locations/add",
        name: "BlacklistLocationsAdder",
        meta: { breadcrumb: true, title: "routeTitles.addLocation" },
        props: { blacklist: true },

        component: () => import("@/views/locations/Editor"),
      },
      {
        path: "/blacklist_locations/:id",
        name: "BlacklistLocationsEditor",
        meta: { breadcrumb: true, title: "routeTitles.editLocation" },
        props: { blacklist: true },
        component: () => import("@/views/locations/Editor"),
      },
      {
        path: "/roles",
        name: "Roles",
        meta: { breadcrumb: true, title: "staffPage.rolesPageTitle" },
        component: () => import("@/views/users/Roles"),
      },
      {
        path: "/passengers/:id",
        meta: { breadcrumb: true, title: "passengersPage.profileTitle" },
        name: "PassengerProfile",
        component: () => import("@/views/passengers/Profile"),
      },
      // {
      //     path: "/captain/performance",
      //     meta: { breadcrumb: true, title: "Captain Performance" },
      //     name: "CaptainPerformance",
      //     component: () => import("@/views/captains/Performance")
      // },
      // {
      //     path: "/captain/acceptance-ratio",
      //     meta: { breadcrumb: true, title: "Acceptance Ratio" },
      //     name: "CaptainAcceptanceRatio",
      //     component: () => import("@/views/captains/AcceptanceRatio")
      // },
      // {
      //     path: "/suggestion_allowed_captain",
      //     meta: { breadcrumb: true, title: "Suggestion Allowed Captain" },
      //     name: "SuggestionAllowedCaptains",
      //     component: () => import("@/views/captains/SuggestionAllowed")
      // },
      // {
      //     path: "/lost_captains",
      //     meta: { breadcrumb: true, title: "Lost Captain" },
      //     name: "LostCaptains",
      //     component: () => import("@/views/captains/Lost")
      // },
      // {
      //     path: '/captains/:id',
      //     meta: { breadcrumb: true, title: "Captain Profile" },
      //     name: 'CaptainProfile',
      //     component: () => import("@/views/captains/Profile")
      // },
      {
        path: "/captains/:id",
        meta: { breadcrumb: true, title: "captainProfilePage.profile.pageTitle" },
        name: "CaptainProfile",
        component: () => import("@/views/captains/CaptainProfile"),
      },
      // {
      //   path: "/captains/:id/monthly-bookings",
      //   meta: { breadcrumb: true, title: "Captain Profile Bookings" },
      //   name: "CaptainProfile",
      //   component: () => import("@/views/captains/CaptainsStatusesTimeline"),
      // },
      {
        path: "/drivers/map",
        meta: { breadcrumb: true, title: "routeTitles.captainsMap" },
        name: "CaptainsMap",
        component: () => import("@/views/tracking/CaptainsMap"),
      },
      {
        path: "/announcements/",
        meta: { breadcrumb: true, title: "routeTitles.driversAnnouncements" },
        name: "DriversAnnouncements",
        component: () => import("@/views/announcements/SendAnnouncements"),
      },
      {
        path: "/drivers/create",
        meta: { breadcrumb: true, title: "routeTitles.createDriver" },
        name: "CreateCaptain",
        component: () => import("@/views/captains/CreateCaptain"),
      },
      {
        path: "/drivers/:id/createCar",
        meta: { breadcrumb: true, title: "routeTitles.createCar" },
        name: "CreateCaptainCar",
        component: () => import("@/views/captains/CreateCaptainCar"),
      },
      {
        path: "/captain_cancellation_reasons",
        meta: { breadcrumb: true, title: "routeTitles.captainCancellationReasons" },
        name: "CaptainCancellationReasons",
        component: () => import("@/views/captain_cancellation_reasons"),
      },
      {
        path: "/cancellation_reasons",
        meta: { breadcrumb: true, title: "routeTitles.cancellationReasons" },
        name: "CancellationReasons",
        component: () => import("@/views/cancellation_reasons"),
      },
      // {
      //     path: '/accounting/transactions',
      //     meta: { breadcrumb: true, title: "Transactions" },
      //     name: 'Transactions',
      //     component: () => import("@/views/accounting/Transactions")
      // },
      // {
      //     path: '/accounting/captain/payments',
      //     meta: { breadcrumb: true, title: "Payments" },
      //     name: 'Payments',
      //     component: () => import("@/views/accounting/Payments")
      // },
      // {
      //     path: '/accounting/captain_balance',
      //     meta: { breadcrumb: true, title: "Captain Balance" },
      //     name: 'Captain Balance',
      //     component: () => import("@/views/accounting/CaptainBalance")
      // },
      // {
      //     path: '/accounting/captain/payments/:id',
      //     meta: { breadcrumb: true, title: "Report" },
      //     name: 'Report',
      //     component: () => import("@/views/accounting/Payment")
      // },
      // QA V4 W4 (#25): the legacy /setting screen (Setting.vue) was deleted.
      // It PUT the entire ~60-key settings map from a page-load snapshot, which
      // is exactly the mass-overwrite that made settings "revert to defaults".
      // The route block was removed so it cannot be re-enabled.
      {
        path: "/settings",
        meta: { breadcrumb: true, title: "settingsPage.pageTitle" },
        name: "Settings",
        component: () => import("@/views/settings/Settings"),
      },
      {
        path: "/dispatching",
        meta: { breadcrumb: true, title: "settingsPage.pageTitle" },
        name: "Dispatching",
        component: () => import("@/views/Dispatching"),
      },
      {
        path: "/reservations",
        meta: { breadcrumb: true, title: "reservationsPage.pageTitle" },
        name: "ReservationsList",
        component: () => import("@/views/ReservationsList"),
      },
      {
        path: "/blockedCaptains",
        meta: { breadcrumb: true, title: "routeTitles.punishment" },
        name: "BlockedCaptains",
        component: () => import("@/views/BlockedCaptains"),
      },
      {
        path: "/events/report",
        meta: { breadcrumb: true, title: "reservationsPage.pageTitle" },
        name: "EventsReport",
        component: () => import("@/views/EventsReport"),
      },
      // {
      //   path: "/testComponent",
      //   meta: { breadcrumb: true, title: "testComponent" },
      //   name: "testComponent",
      //   component: () => import("@/views/testComponent"),
      // },
      {
        path: "/shifts/map",
        meta: { breadcrumb: true, title: "routeTitles.shiftsMap" },
        name: "ShiftsMap",
        component: () => import("@/views/planning/ShiftsMap"),
      },
      {
        path: "/testMaps",
        meta: { breadcrumb: true, title: "routeTitles.testMaps" },
        name: "testMaps",
        component: () => import("@/views/planning/testMaps"),
      },
      {
        path: "/events",
        meta: { breadcrumb: true, title: "routeTitles.events" },
        name: "Events",
        component: () => import("@/views/planning/Events"),
      },
      {
        path: "reservation_queue",
        meta: { breadcrumb: true, title: "routeTitles.reservationQueue" },
        name: "ReservationQueue",
        component: () => import("@/views/reservationQueue/ReservationQueue"),
      },
      {
        path: "/shifts",
        meta: { breadcrumb: true, title: "routeTitles.shifts" },
        name: "Shifts",
        component: () => import("@/views/shifts/Shifts"),
      },
      {
        path: "/terms_and_conditions",
        meta: { breadcrumb: true, title: "routeTitles.termsAndConditions" },
        name: "TermsAndConditions",
        component: () => import("@/views/termsAndConditions/TermsAndConditions"),
      },
      {
        path: "/terms_and_conditions/create",
        meta: { breadcrumb: true, title: "routeTitles.createTermsAndConditions" },
        name: "CreateTermsAndConditions",
        component: () => import("@/views/termsAndConditions/CreateTermsAndConditions"),
      },
      {
        path: "/events/create",
        meta: { breadcrumb: true, title: "routeTitles.createEvent" },
        name: "CreateEvent",
        component: () => import("@/views/planning/CreateEvent"),
      },
      {
        path: "/events/:id",
        meta: { breadcrumb: true, title: "routeTitles.eventDetails" },
        name: "EventDetails",
        component: () => import("@/views/planning/EventDetails"),
      },
      {
        path: "/broadcast",
        meta: { breadcrumb: true, title: "routeTitles.broadcast" },
        name: "Broadcast",
        component: () => import("@/views/Broadcast"),
      },
      {
        path: "/monitor",
        meta: { breadcrumb: true, title: "routeTitles.monitor" },
        name: "Monitor",
        component: () => import("@/views/monitoring/Monitor"),
      },
      {
        path: "/rides_search",
        meta: { breadcrumb: true, title: "routeTitles.ridesSearch" },
        name: "RidesSearch",
        component: () => import("@/views/monitoring/RidesSearch"),
      },
      {
        path: "/bookings",
        meta: { breadcrumb: true, title: "ridesListPage.pageTitle" },
        name: "BookingsList",
        component: () => import("@/views/rides/RidesList"),
      },
      {
        path: "/booking-complaints",
        meta: { breadcrumb: true, title: "routeTitles.bookingComplaints" },
        name: "BookingComplaints",
        component: () => import("@/views/bookings/BookingComplaints"),
      },
      {
        path: "/analytics/summary",
        meta: { breadcrumb: true, title: "routeTitles.analyticsSummary" },
        name: "AnalyticsSummary",
        component: () => import("@/views/analytics/AnalyticsSummary"),
      },
      {
        // Backward compatible: old rides list URL
        path: "/rides",
        redirect: { name: "BookingsList" },
      },
      {
        path: "/messages",
        meta: { title: "routeTitles.messages" },
        name: "Messages",
        component: () => import("@/views/Messages"),
      },
      {
        path: "/log/:id",
        meta: { breadcrumb: true, title: "routeTitles.bookingLog" },
        name: "BookingLog",
        component: () => import("@/views/BookingLog"),
      },
      {
        path: "/create-bookings",
        meta: { breadcrumb: true, title: "createBookingPage.pageTitle" },
        name: "CreateBooking",
        component: () => import("@/views/dispatching/CreateBooking"),
      },
      {
        path: "/surveys",
        meta: { breadcrumb: true, title: "routeTitles.surveys" },
        name: "Surveys",
        component: () => import("@/views/surveys/surveys"),
      },
      {
        path: "/survey/:id",
        meta: { breadcrumb: true, title: "routeTitles.survey" },
        name: "Survey",
        component: () => import("@/views/surveys/survey"),
      },
      {
        path: "/surveys/create",
        meta: { breadcrumb: true, title: "routeTitles.createSurvey" },
        name: "CreateSurvey",
        component: () => import("@/views/surveys/CreateSurvey"),
      },
      {
        path: "/constraints",
        meta: { breadcrumb: true, title: "routeTitles.constraints" },
        name: "Constraints",
        component: () => import("@/views/constraints/Constraints"),
      },
      {
        path: "/constraints/create",
        meta: { breadcrumb: true, title: "routeTitles.createConstraint" },
        name: "CreateConstraint",
        component: () => import("@/views/constraints/CreateConstraint"),
      },
      {
        path: "/constraints/edit/:id",
        meta: { breadcrumb: true, title: "routeTitles.editConstraint" },
        name: "EditConstraint",
        component: () => import("@/views/constraints/EditConstraint"),
      },
      {
        path: "/priceRules",
        meta: { breadcrumb: true, title: "priceRulesPage.pageTitle" },
        name: "PriceRules",
        component: () => import("@/views/priceRules/PriceRules"),
      },
      {
        path: "/priceRules/edit/:id",
        meta: { breadcrumb: true, title: "priceRulesPage.editPageTitle" },
        name: "EditPriceRules",
        component: () => import("@/views/priceRules/EditPriceRules"),
      },
      {
        path: "/priceRules/create",
        meta: { breadcrumb: true, title: "priceRulesPage.createPageTitle" },
        name: "CreatePriceRules",
        component: () => import("@/views/priceRules/CreatePriceRules"),
      },
      {
        path: "/complaints",
        meta: { breadcrumb: true, title: "routeTitles.userComplaints" },
        name: "Complaints",
        component: () => import("@/views/complaints/ComplaintsPage"),
      },
      {
        path: "/vacations",
        meta: { breadcrumb: true, title: "routeTitles.vacations" },
        name: "Vacations",
        component: () =>
          import("@/views/Vacations"),
      },
      {
        path: "/scheduled_messages",
        meta: { breadcrumb: true, title: "routeTitles.globalMessages" },
        name: "scheduled_messages",
        component: () => import("@/views/global_messages/GlobalMessages"),
      },
      {
        path: "/scheduled_messages/store",
        meta: { breadcrumb: true, title: "routeTitles.globalMessages" },
        name: "create_scheduled_messages",
        component: () => import("@/views/global_messages/CreateGlobalMessage"),
      },
      {
        path: "/MaxBookingCount",
        meta: { breadcrumb: true, title: "routeTitles.maxBookingCount" },
        name: "MaxBookingCount",
        component: () =>
          import("@/views/MaxBookingCount"),
      },
      {
        path: "/seasonal_reservations",
        meta: { breadcrumb: true, title: "routeTitles.seasonalReservations" },
        name: "seasonal_drivers_reservations_allowance_special_cases",
        component: () => import("@/views/seasonal_reservations/SeasonalReservations"),
      },
      {
        path: "/payments",
        alias: "/accounting",
        meta: { breadcrumb: true, title: "finance.payments.pageTitle" },
        name: "payments",
        component: () => import("@/views/payments/Payments"),
      },
      {
        path: "/accounting/captains/:captainId/ledger",
        meta: { breadcrumb: true, title: "finance.ledger.pageTitle" },
        name: "CaptainLedger",
        component: () => import("@/views/finance/CaptainLedger"),
      },
      {
        path: "/accounting/chart-of-accounts",
        meta: { breadcrumb: true, title: "finance.coa.pageTitle" },
        name: "ChartOfAccounts",
        component: () => import("@/views/finance/ChartOfAccounts"),
      },
      {
        path: "/accounting/journal-entries",
        meta: { breadcrumb: true, title: "finance.journals.pageTitle" },
        name: "JournalEntries",
        component: () => import("@/views/finance/JournalEntries"),
      },
      {
        path: "/accounting/assets",
        meta: { breadcrumb: true, title: "finance.assets.pageTitle" },
        name: "AssetEntries",
        component: () => import("@/views/finance/Assets"),
      },
      {
        path: "/accounting/adjustments",
        meta: { breadcrumb: true, title: "finance.adjustments.pageTitle" },
        name: "CaptainAdjustments",
        component: () => import("@/views/finance/Adjustments"),
      },
      {
        path: "/accounting/reports",
        meta: { breadcrumb: true, title: "finance.reports.pageTitle" },
        name: "FinanceReports",
        component: () => import("@/views/finance/Reports"),
      },
      // Unified report engine (requirements doc 2026-09-09). The catalog is
      // the complete map of the document's fifty reports; ReportPage renders
      // any of them from server-supplied metadata.
      {
        path: "/reports",
        meta: { breadcrumb: true, title: "reports.catalogTitle" },
        name: "ReportCatalog",
        component: () => import("@/views/reports/ReportCatalog"),
      },
      {
        path: "/reports/:slug",
        meta: { breadcrumb: true, title: "reports.pageTitle" },
        name: "ReportPage",
        component: () => import("@/views/reports/ReportPage"),
      },
      {
        path: "/accounting/reports/trial-balance",
        meta: { breadcrumb: true, title: "finance.trialBalance.pageTitle" },
        name: "TrialBalance",
        component: () => import("@/views/finance/TrialBalance"),
      },
      {
        path: "/accounting/reports/balance-sheet",
        meta: { breadcrumb: true, title: "finance.balanceSheet.pageTitle" },
        name: "BalanceSheet",
        component: () => import("@/views/finance/BalanceSheet"),
      },
      {
        path: "/accounting/reports/income-statement",
        meta: { breadcrumb: true, title: "finance.incomeStatement.pageTitle" },
        name: "IncomeStatement",
        component: () => import("@/views/finance/IncomeStatement"),
      },
      // Accountant's document 2026-10-03, section 2: the seven ledger
      // reports. Route names = the backend Legacy catalog definitions'
      // legacyView(), so the reports catalog opens them.
      {
        path: "/accounting/reports/general-journal-summary",
        meta: { breadcrumb: true, title: "finance.reports2.generalJournalSummary.pageTitle" },
        name: "GeneralJournalSummary",
        component: () => import("@/views/finance/GeneralJournalSummary"),
      },
      {
        path: "/accounting/reports/driver-statement",
        meta: { breadcrumb: true, title: "finance.reports2.driverStatement.pageTitle" },
        name: "DriverStatement",
        component: () => import("@/views/finance/DriverStatement"),
      },
      {
        path: "/accounting/reports/cash-flow-statement",
        meta: { breadcrumb: true, title: "finance.reports2.cashFlowStatement.pageTitle" },
        name: "CashFlowStatement",
        component: () => import("@/views/finance/CashFlowStatement"),
      },
      {
        path: "/accounting/reports/equity-changes",
        meta: { breadcrumb: true, title: "finance.reports2.equityChanges.pageTitle" },
        name: "EquityChanges",
        component: () => import("@/views/finance/EquityChanges"),
      },
      {
        path: "/accounting/reports/account-statement",
        meta: { breadcrumb: true, title: "finance.reports2.accountStatement.pageTitle" },
        name: "AccountStatement",
        component: () => import("@/views/finance/AccountStatement"),
      },
      {
        path: "/accounting/reports/accounting-balance",
        meta: { breadcrumb: true, title: "finance.reports2.accountingBalance.pageTitle" },
        name: "AccountingBalance",
        component: () => import("@/views/finance/AccountingBalance"),
      },
      {
        path: "/accounting/reports/accounts-inventory",
        meta: { breadcrumb: true, title: "finance.reports2.accountsInventory.pageTitle" },
        name: "AccountsInventory",
        component: () => import("@/views/finance/AccountsInventory"),
      },
      {
        path: "/accounting/posting-rules",
        meta: { breadcrumb: true, title: "finance.postingRules.pageTitle" },
        name: "PostingRules",
        component: () => import("@/views/finance/PostingRules"),
      },
      // Period locking (accountant's decisions doc 2026-09-10, answer 2):
      // closing a month refuses every later entry dated into it and freezes
      // that month's report snapshots.
      {
        path: "/accounting/period-locks",
        meta: { breadcrumb: true, title: "finance.periodLocks.pageTitle" },
        name: "PeriodLocks",
        component: () => import("@/views/finance/PeriodLocks"),
      },
      // Employees and their monthly payroll sheet (answer 3b). The payroll
      // components are a panel on this page rather than a route of their own:
      // a component has no meaning apart from the employee and month it
      // belongs to, so reaching one without first choosing them is not a
      // state worth having a URL for.
      {
        path: "/accounting/employees",
        meta: { breadcrumb: true, title: "finance.employees.pageTitle" },
        name: "Employees",
        component: () => import("@/views/finance/Employees"),
      },
      // Vehicle maintenance register (answer 3a). Under /fleet rather than
      // /accounting: it is entered by fleet staff and gated on DRIVERS, even
      // though its cost is what feeds expense account 51313.
      {
        path: "/fleet/car-maintenance",
        meta: { breadcrumb: true, title: "fleet.maintenance.pageTitle" },
        name: "CarMaintenance",
        component: () => import("@/views/fleet/CarMaintenance"),
      },
      {
        path: "/agent",
        meta: { breadcrumb: true, title: "agent.pageTitle" },
        name: "AgentPanel",
        component: () => import("@/views/agent/AgentPanel"),
      },
      {
        path: "/seasonal_reservations/store",
        meta: { breadcrumb: true, title: "routeTitles.createSeasonalReservation" },
        name: "create_seasonal_drivers_reservations_allowance",
        component: () => import("@/views/seasonal_reservations/CreateSeasonalReservation"),
      },
      {
        path: "/seasonal_reservations/edit/:id",
        meta: { breadcrumb: true, title: "routeTitles.editSeasonalReservation" },
        name: "edit_seasonal_drivers_reservations_allowance",
        component: () => import("@/views/seasonal_reservations/EditSeasonalReservation"),
      },
      {
        path: "/sms_codes",
        meta: { breadcrumb: true, title: "priceRulesPage.smsCodes.pageTitle" },
        name: "sms_codes",
        component: () => import("@/views/sms_codes/SmsCodes"),
      },
      {
        path: "/captain_complaints_no_booking/:id",
        meta: { breadcrumb: true, title: "routeTitles.captainComplaints" },
        name: "captain_complaints",
        component: () => import("@/views/captain_complaints_no_booking/CaptainComplaintsNoBooking"),
      },
      {
        path: "/lost_and_found",
        meta: { breadcrumb: true, title: "routeTitles.lostAndFound" },
        name: "lost_and_found",
        component: () => import("@/views/lost_and_found/LostAndFound"),
      },
      {
        path: "/lost_and_found/store",
        meta: { breadcrumb: true, title: "routeTitles.createLostAndFound" },
        name: "create_lost_and_found",
        component: () => import("@/views/lost_and_found/CreateLostAndFound"),
      },
      {
        path: "/lost_and_found/edit/:id",
        meta: { breadcrumb: true, title: "routeTitles.editLostAndFound" },
        name: "edit_lost_and_found",
        component: () => import("@/views/lost_and_found/EditLostAndFound"),
      },
      // {
      //     path: '/customer_care/tickets_management',
      //     meta: { breadcrumb: true, title: "TicketsManagement" },
      //     name: 'TicketsManagement',
      //     component: () => import("@/views/customer_care/ticketing/TicketsManagement")
      // },
      // {
      //     path: "/customer_care/tickets",
      //     meta: { breadcrumb: true, title: "Tickets" },
      //     name: "Tickets",
      //     component: () => import("@/views/customer_support/Tickets")
      // },
      // {
      //     path: '/customer_care/tickets/:id',
      //     meta: { breadcrumb: true, title: "Ticket" },
      //     name: 'Ticket',
      //     component: () => import("@/views/customer_care/ticketing/Ticket")
      // },
      // {
      //     path: '/money_transfer',
      //     meta: {breadcrumb: true, title: "Money Transfer"},
      //     name: "MoneyTransfer",
      //     component: () => import("@/views/MoneyTransfer")
      // },
      // {
      //     path: '/airport/create',
      //     meta: {breadcrumb: true, title: "Create"},
      //     name: 'AirportCreate',
      //     component: () => import("@/views/Airport/create")
      // },
      // {
      //     path: '/airport/index',
      //     meta: {breadcrumb: true, title: "Index"},
      //     name: 'AirportIndex',
      //     component: () => import("@/views/Airport/Index")
      // },
      // {
      //     path: '/market/create',
      //     meta: {breadcrumb: true, title: "Create"},
      //     name: 'MarketCreate',
      //     component: () => import("@/views/Market/create")
      // },
      // {
      //     path: '/market/index',
      //     meta: {breadcrumb: true, title: "Index"},
      //     name: 'MarketIndex',
      //     component: () => import("@/views/Market/Index")
      // },
      // {
      //     path: '/beesline/area_clusters',
      //     meta: {breadcrumb: true, title: "Index"},
      //     name: 'BeeslineAreaClusters',
      //     component: () => import("@/views/beesline/AreaClusters")
      // },
      // {
      //     path: '/beesline/setting',
      //     meta: {breadcrumb: true, title: "Index"},
      //     name: 'BeeslineSettings',
      //     component: () => import("@/views/beesline/BeeslineSetting")
      // },
      // {
      //     path: '/promoter_page',
      //     meta: {breadcrumb: true, title: "PromoterPage"},
      //     name: 'PromoterPage',
      //     component: () => import("@/views/PromoterPage")
      // },

      // {
      //     path: '/beesline/area_clusters',
      //     meta: {breadcrumb: true, title: "Index"},
      //     name: 'BeeslineAreaClusters',
      //     component: () => import("@/views/beesline/AreaClusters")
      // },
      // {
      //     path: "/beesline/stores",
      //     meta: {breadcrumb: true, title: "Beesline - Stores"},
      //     name: "BeeslineStores",
      //     component: () => import("@/views/beesline/Stores")
      // },
      // {
      //     path: "/beesline/statistics",
      //     meta: {breadcrumb: true, title: "Beesline - Statistics"},
      //     name: "BeeslineStatistics",
      //     component: () => import("@/views/beesline/Statistics")
      // },
      // {
      //     path: '/accounting/cash_register',
      //     meta: { breadcrumb: true, title: "Cash Registers" },
      //     name: 'Cash Registers',
      //     component: () => import("@/views/accounting/cash_register/Index")
      // },
      // {
      //     path: '/accounting/cash_register/:id',
      //     meta: { breadcrumb: true, title: "Cash Register" },
      //     name: 'Cash Register',
      //     component: () => import("@/views/accounting/cash_register/CashRegister")
      // },
      // {
      //     path: '/accounting/pending_transactions',
      //     meta: { breadcrumb: true, title: "PendingTransactions" },
      //     name: 'Pending Transactions',
      //     component: () => import("@/views/accounting/cash_register/PendingTransactions")
      // },
      // {
      //     path: '/accounting/bonus_requests',
      //     meta: { breadcrumb: true, title: "Bonus Requests" },
      //     name: 'Bonus Requests',
      //     component: () => import("@/views/accounting/BonusRequests")
      // }
    ],
  },
];
